import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

// COMPONENTS
import B2CReception from '../B2C/Reception';
import LabelPage from '../B2C/LabelPage';
import B2CLabel from '../B2C/Label';
import { isFunctionHaveProperRight } from '../../helper/AuthorizationUtils';
import { MODULE_FUNCTIONS, RIGHTS } from '../../helper/permissions';

const mapStateToProps = (state) => {
    return {        
        rights: state.user.rights,
        rightObjects: state.user.rightObjects || [],        
    }
}

const mapDispatchToProps = {
}

const B2C = ({ match, rightObjects, rights }) => (
    <Fragment>
        {isFunctionHaveProperRight(rightObjects, rights, MODULE_FUNCTIONS.B2CRECEPTION, RIGHTS.VIEW) ?
            <Route path={`${match.url}/reception`} component={B2CReception} />
            : null}
        {isFunctionHaveProperRight(rightObjects, rights, MODULE_FUNCTIONS.B2CLABELS, RIGHTS.VIEW) ?
            <Route path={`${match.url}/label`} component={B2CLabel} />
            : null}                  
        <Route path={`${match.url}/labelPage`} component={LabelPage} />
    </Fragment>
);

export default connect(mapStateToProps, mapDispatchToProps)(B2C);
